import { configureStore, createReducer } from '@reduxjs/toolkit';

import {
  breadcrumbsApi,
  citiesApi,
  contentApi,
  currencyRatesApi,
  organizationsApi,
  productsApi,
} from '@/queries';

export const makeStore = ({ initialStore }) =>
  configureStore({
    reducer: {
      [productsApi.reducerPath]: productsApi.reducer,
      [contentApi.reducerPath]: contentApi.reducer,
      [breadcrumbsApi.reducerPath]: breadcrumbsApi.reducer,
      [organizationsApi.reducerPath]: organizationsApi.reducer,
      [citiesApi.reducerPath]: citiesApi.reducer,
      [currencyRatesApi.reducerPath]: currencyRatesApi.reducer,
      organizationsSlugs: createReducer(
        initialStore,
        () => initialStore.organizationsSlugs
      ),
    },
    preloadedState: initialStore,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      })
        .concat(organizationsApi.middleware)
        .concat(productsApi.middleware)
        .concat(contentApi.middleware)
        .concat(citiesApi.middleware)
        .concat(currencyRatesApi.middleware)
        .concat(breadcrumbsApi.middleware),
  });

export default makeStore;
